/* Concept borrowed from:
 * https://dev.to/rajeshroyal/reactjs-disable-consolelog-in-production-and-staging-3l38
*/

export const DisableConsole = (function () {
  var savedConsole = console;
  /**
  * @param {boolean} isDisabled
  * @param {boolean} suppressAll
  */
  return function (isDisabled, suppressAll) {
    var suppress = suppressAll || true;
    if (isDisabled === true) {
      // supress the default console functionality
      console = {};
      console.log = function () {};
      // supress all type of consoles
      if (suppress) {
        console.info = function () {};
        console.warn = function () {};
        console.error = function () {};
        console.debug = function () {};
      } else {
        console.info = savedConsole.info;
        console.warn = savedConsole.warn;
        console.error = savedConsole.error;
        console.debug = savedConsole.debug;
      }
    } else {
      console = savedConsole;
    }
  };
})();